import React, {useRef, useState} from "react";
import {useAppContext} from "../context/AppContext";

type FourDigitPinProps = {
  responseObject: {
    message: string;
    pin: string | null;
    error: string;
  };
  email: string;
  onValidated?: () => void;
};

const FourDigitPin = ({
  responseObject,
  email,
  onValidated,
}: FourDigitPinProps) => {
  const {setIsLogin} = useAppContext();
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [code, setCode] = useState(["", "", "", ""]);
  const [errorMessage, setErrorMessage] = useState("");

  // Normalize pin from API
  const expectedPin = (responseObject?.pin ?? "").toString().trim();

  const updateCodeAtIndex = (value: string, index: number) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
  };

  const handleChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return; // allow only digits

    updateCodeAtIndex(value, index);

    // Auto-focus next input
    if (value && index < code.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      updateCodeAtIndex("", index - 1);
      inputRefs.current[index - 1]?.focus();
    }
  };

  const onValidateAccount = () => {
    setErrorMessage("");
    const enteredPin = code.join("");

    if (enteredPin.length < 4) {
      setErrorMessage("Please enter all 4 digits of the code.");
      return;
    }

    if (enteredPin === expectedPin) {
      localStorage.setItem("iris-portal-signed", "true");

      // ✅ re-check localStorage and update context state
      const isSigned = localStorage.getItem("iris-portal-signed") === "true";
      if (isSigned) {
        setIsLogin(true);
        if (onValidated) onValidated();
      }
    } else {
      setErrorMessage("Invalid code. Please try again.");
    }
  };
  return (
    <div className="login-main-content verify-account-blk">
      <h2 className="verify-title">Check your email</h2>
      <p className="verify-subtitle">
        A one-time 4-digit code has been sent to <br />
        <span>{email}</span>
      </p>

      <div className="verify-inputs">
        {code.map((digit, idx) => (
          <input
            key={idx}
            type="text"
            maxLength={1}
            value={digit}
            ref={(el: any) => (inputRefs.current[idx] = el)}
            onChange={(e) => handleChange(e.target.value, idx)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
            onFocus={(e) => e.target.select()}
            className="verify-input"
          />
        ))}
      </div>

      <button type="button" onClick={onValidateAccount} className="verify-btn">
        Access Website
      </button>
      {errorMessage && <p className="error-message-blk">{errorMessage}</p>}
    </div>
  );
};

export default FourDigitPin;
